import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { useEnv } from "@/core/env";
import { useDeviceDetection } from "@/core/hooks";
import AppleAppStoreButton from "@/assets/images/apple-app-store-button.png";
import GooglePlayButton from "@/assets/images/google-play-store-button.png";
import MobileAppSideBySide from "@/assets/images/mobile-app-side-by-side.png";

const STORE_BUTTON_WIDTH = 189;

export const ENV_TO_ANDROID_PACKAGE_NAME = {
  development: "com.volca-dev.Volca",
  staging: "com.volca_staging.Volca",
  demo: "com.volca-demo.Volca",
  production: "com.volca.Volca",
};

export const getStoreUrls = (appEnv: string) => ({
  android: `https://play.google.com/store/apps/details?id=${ENV_TO_ANDROID_PACKAGE_NAME[appEnv as keyof typeof ENV_TO_ANDROID_PACKAGE_NAME]}`,
  ios: "https://apps.apple.com/us/app/volca/id6737725699", // Replace with actual App Store ID
});

// Custom hook to detect device type - removed and imported from core hooks

const GetVolca = () => {
  const { appEnv } = useEnv();
  const deviceType = useDeviceDetection();
  const storeUrls = getStoreUrls(appEnv);

  const isDesktop = deviceType === "desktop";

  const renderStoreButtons = () => {
    // On desktop, show both buttons
    if (deviceType === "desktop") {
      return (
        <Stack
          direction="row"
          gap="md"
          justify="center"
          align="center"
          fullWidth
        >
          <img
            src={AppleAppStoreButton}
            alt="Download on App Store"
            className="w-full cursor-pointer"
            style={{ width: STORE_BUTTON_WIDTH }}
            onClick={() => window.open(storeUrls.ios, "_blank")}
          />
          <img
            src={GooglePlayButton}
            alt="Download on Google Play"
            className="w-full cursor-pointer"
            style={{ width: STORE_BUTTON_WIDTH }}
            onClick={() => window.open(storeUrls.android, "_blank")}
          />
        </Stack>
      );
    }

    // On iOS, show only Apple App Store button
    if (deviceType === "ios") {
      return (
        <img
          src={AppleAppStoreButton}
          alt="Download on App Store"
          className="cursor-pointer"
          style={{ width: STORE_BUTTON_WIDTH }}
          onClick={() => window.open(storeUrls.ios, "_blank")}
        />
      );
    }

    // On Android, show only Google Play button
    return (
      <img
        src={GooglePlayButton}
        alt="Download on Google Play"
        className="cursor-pointer"
        style={{ width: STORE_BUTTON_WIDTH }}
        onClick={() => window.open(storeUrls.android, "_blank")}
      />
    );
  };

  return (
    <Stack className="mt-6 h-full" justify="center" align="center" fullWidth>
      <Stack
        className="flex-1 p-6"
        justify={isDesktop ? "center" : "start"}
        align="center"
        fullWidth
      >
        <Card className="w-full max-w-2xl p-6">
          <Stack gap="lg" justify="center" align="center" fullWidth>
            <Stack justify="center" align="center" fullWidth>
              <Typography
                variant="subtitleW1"
                className="text-center leading-8"
              >
                Track your referrals with the Volca mobile app.{" "}
                {!isDesktop && "Download to your phone below"}
              </Typography>
              {isDesktop && (
                <Typography variant="subtitleW1">
                  Download to your phone below
                </Typography>
              )}
            </Stack>

            {renderStoreButtons()}
          </Stack>
        </Card>
      </Stack>

      {isDesktop && (
        <img
          src={MobileAppSideBySide}
          alt="Mobile App Side by Side"
          className="w-full cursor-pointer"
          style={{ width: 568 }}
        />
      )}
    </Stack>
  );
};

export default GetVolca;
